import React, { useContext } from 'react';

import { ControlCategorySpec } from 'src/models/Sidekick/SidekickModuleSpec';
import ControlCategory from './ControlCategory';
import ExternalAction from './ExternalActions/ExternalAction';
import { ThreadModuleContext } from './ThreadModuleContext';

type ControlsProps = {
  controlCategorySpecs: ControlCategorySpec[] | null;
};

export default function Controls({ controlCategorySpecs }: ControlsProps) {
  const { readOnly } = useContext(ThreadModuleContext);

  if (!controlCategorySpecs || controlCategorySpecs.length === 0) {
    return null;
  }

  return (
    <>
      <ExternalAction disabled={readOnly} />
      {controlCategorySpecs.map((controlCategorySpec, idx) => (
        <ControlCategory specAttr={`controlCategories.${idx}`} key={idx} controlCategorySpec={controlCategorySpec} />
      ))}
    </>
  );
}
